// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
class _BrowserUtils {
    constructor() {
        this.isChrome = (() => {
            const browser = this.getBrowserVersion();
            return !(!browser.includes('Chrome') && !browser.includes('chrome'));
        })();
        this.isSafari = (() => {
            const browser = this.getBrowserVersion();
            return browser.includes('Safari');
        })();
        this.isEdgeOrIEBrowser = (() => {
            const browser = this.getBrowserVersion();
            return !(!browser.includes('IE') && !browser.includes('Edge'));
        })();
        // BrowserUtils.log  (logOptions = {})
        // {
        //     const {
        //         text = '',
        //         color = this.LOGS_DEFAULT_TEXT_COLOR,
        //         background = this.LOGS_DEFAULT_BACKGROUND_COLOR,
        //         objectToLog,
        //         objectToLogDescription,
        //         showObjectToLogAsTable = false,
        //         needTraceCallStack = false,
        //         debugMode = this.isDebug()
        //     } = logOptions;
        //     if (!debugMode)
        //         return;
        //     // const ticker = this.getTVSymbol();
        //     // const panelIns = this.GetInstrument();
        //     // const panelInsName = panelIns ? panelIns.DisplayName() : 'INSTRUMENT_IS_ABSENT';
        //     // const cISeries = this.cashItemSeries;
        //     // const cashItemIns = cISeries ? cISeries.CashItem.Instrument : null;
        //     // const cashItemInsName = cashItemIns ? cashItemIns.DisplayName() : 'CASH_ITEM_SERIES_IS_ABSENT';
        //     const callerFull = this.getCallerName();
        //     const callerMethod = this.getMethodName(callerFull);
        //     const generalLogs = callerFull;
        //     const noMainText = !text || text.lastIndexOf(':') == text.length - 1;
        //     const logsText = `[${callerMethod}]: ` + text + (noMainText ? generalLogs : '');
        //     const seemsToBeAllright = true //panelIns && cashItemIns;
        //     const logsBackgroundColor = seemsToBeAllright ? background : 'red';
        //     const logsTextColor = seemsToBeAllright ? color : 'white';
        //     const logsStyle = 'background: ' + logsBackgroundColor + '; color: ' + logsTextColor + ';';
        //     // if (!seemsToBeAllright)
        //     //     console.error('NO INSTRUMENT IN ' + (panelIns ? 'CASHITEM' : 'PANEL'));
        //     console.groupCollapsed('%c' + logsText, logsStyle);       // MainText
        //     if (!noMainText)
        //         console.log('%c' + generalLogs, logsStyle);  // General for all logs text
        //     if (objectToLogDescription)
        //         console.log('%c', logsStyle, objectToLogDescription);
        //     if (objectToLog)
        //     {
        //         if (showObjectToLogAsTable)
        //             console.table(objectToLog);
        //         else
        //             console.log('%c', logsStyle, objectToLog);
        //     }
        //     if (needTraceCallStack)
        //     {
        //         console.groupCollapsed('%cCall stack', logsStyle);
        //         console.trace();
        //         console.groupEnd();
        //     }
        //     console.groupEnd();
        // }
        this.LOGS_DEFAULT_TEXT_COLOR = '#e8eaed';
        this.LOGS_DEFAULT_BACKGROUND_COLOR = '#171616'; /* Chrome's default console background color=#222 */
        this.regexpSymbol = /[\<\>\|\:\/\"\*\?\\]/;
        this.regexpEnd = /[\.\s]$/;
        this.regexpText = /\b(COM|LPT)[1-9]|(CON|PRN|AUX|NUL)\b/i;
    }
    /**
     * Extract a specific query parameter from a URL.
     * @param url The URL from which to extract the query parameter.
     * @param param The name of the query parameter to extract.
     * @returns The value of the query parameter, or null if not found or invalid.
     */
    getQueryParamFromUrl(url, param) {
        try {
            if (!url) {
                console.error('URL is null or undefined');
                return null;
            }
            const urlObj = new URL(url);
            const params = new URLSearchParams(urlObj.search);
            return params.get(param);
        }
        catch (error) {
            console.error('Invalid URL or error parsing URL:', error);
            return null;
        }
    }
    getBrowserVersion() {
        if (typeof navigator === 'undefined') {
            return 'Unknown browser';
        }
        const ua = navigator.userAgent;
        let tem;
        let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) {
                return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return M.join(' ');
    }
    isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
    }
    RemoveHTMLTags(html) {
        // #112820 + #114020
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('style, script').forEach((el) => {
            el.remove();
        });
        return doc.body.innerText.trim();
    }
    getUrlVars(url) {
        const vars = {};
        url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
            vars[key] = value;
        });
        return vars;
    }
    isEmail(email) {
        const regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }
    getCallerName() {
        try {
            throw new Error();
        }
        catch (e) {
            const stackLines = e.stack.split('at ');
            return stackLines[3].split('\n')[0];
        }
    }
    getMethodName(callerName) {
        if (!callerName) {
            return '';
        }
        const caller = callerName.split(' (')[0];
        const splitByPoint = caller.split('.');
        return splitByPoint[splitByPoint.length - 1];
    }
    isDebug() {
        return window && window.location && window.location.href === 'http://localhost:3000/';
    }
}
export const BrowserUtils = new _BrowserUtils();
